var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCellTower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2998 14.7L8.4998 13.5C7.4998 12.5 6.9998 11.2 6.9998 10C6.9998 8.70005 7.4998 7.40005 8.4998 6.50005L7.2998 5.30005C5.9998 6.60005 5.2998 8.30005 5.2998 10C5.2998 11.7 5.9998 13.4 7.2998 14.7Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0999 2.90002L17.8999 4.10002C19.4999 5.70002 20.2999 7.90002 20.2999 10C20.2999 12.1 19.4999 14.3 17.8999 15.9L19.0999 17.1C21.0999 15.1 21.9999 12.6 21.9999 10C21.9999 7.40002 20.9999 4.90002 19.0999 2.90002Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 4.10002L4.9 2.90002C3 4.90002 2 7.40002 2 10C2 12.6 3 15.1 4.9 17.1L6.1 15.9C4.5 14.3 3.7 12.1 3.7 10C3.7 7.90002 4.5 5.70002 6.1 4.10002Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 14.7C18 13.4 18.7 11.7 18.7 10C18.6 8.30005 18 6.60005 16.7 5.30005L15.5 6.50005C16.5 7.50005 17 8.80005 17 10C17 11.3 16.5 12.6 15.5 13.5L16.7 14.7Z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10C14.5 8.62 13.38 7.5 12 7.5C10.62 7.5 9.5 8.62 9.5 10C9.5 10.76 9.84 11.42 10.37 11.88L7 22H9L9.67 20H14.34L15 22H17L13.63 11.88C14.16 11.42 14.5 10.76 14.5 10ZM10.33 18L12 13L13.67 18H10.33Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellTower);
export default __webpack_public_path__ + "static/media/cellTower.bc943349fab1d1b04c035aeb8deb6985.svg";
export { ForwardRef as ReactComponent };